import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT ------------------------------------------------
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------- COMPONENTES DE BASE -----------------------------------------------------
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { formatDate } from "../../../../../Base/Services/FechasService";
import { getDateStringCeros } from "../../../../../Base/Services/Moment/Luxon";
import { getInformacionEmpresa } from "../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";

// ------------------- CONSULTAS A LA API -------------------------------------------------------
import { getSolicitudEdicionId } from "../../../../../API/Compras/Proveedores/ProveedoresRequest";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const esVerdadero = (valor) => {
  if (valor === null || valor === undefined) return false;
  if (typeof valor === "boolean") return valor;
  if (typeof valor === "number") return valor === 1;

  const v = String(valor).trim().toLowerCase();

  return ["1", "true", "si", "sí", "s"].includes(v);
};

const renderCheckboxRow = (valor, label) => ({
  columns: [
    {
      width: 12,
      canvas: [
        {
          type: "rect",
          x: 0,
          y: 0,
          w: 10,
          h: 10,
          r: 1,
          lineWidth: 1,
          lineColor: "#000000",
          color: esVerdadero(valor) ? "#000000" : undefined,
        },
      ],
      margin: [2, 2, 0, 0],
    },
    {
      width: "*",
      text: label,
      style: "checkboxLabel",
      margin: [4, 0, 0, 0],
    },
  ],
  columnGap: 2,
});

const SECCIONES = [
  { key: "InformacionEmpresa", label: "Información de Empresa" },
  { key: "InformacionContacto", label: "Información de Contacto" },
  { key: "InformacionBancaria", label: "Información Bancaria" },
  { key: "InformacionComercial", label: "Información Comercial" },
  { key: "InformacionFinanciera", label: "Información Financiera" },
  { key: "Documentacion", label: "Documentación" },
  { key: "Reactivar", label: "Reactivar" },
  { key: "HabilitarPago", label: "Habilitar Pago" },
];

const ReporteSolicitudEdicionProveedor = ({
  dialog,
  hideDialog,
  IdSolicitudEdicion,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [data, setData] = useState({});

  const obtenerInformacion = async () => {
    try {
      const infoEmpresaTempo = await getInformacionEmpresa();

      const empresa = {
        name: infoEmpresaTempo[0]?.NombreLegal || "",
        direccion: infoEmpresaTempo[0]?.Direccion || "",
        RTNEmpresa: infoEmpresaTempo[0]?.RTN || "",
        logoB64: infoEmpresaTempo[0]?.LogoPrimarioB64 || "",
      };

      const result = await getSolicitudEdicionId(IdSolicitudEdicion);

      let solicitud = result;

      if (Array.isArray(result) && result.length > 0) {
        solicitud = result[0];
      }

      if (solicitud?.IdSolicitudEdicion) {
        setData(solicitud);
        await generarPDF(solicitud, empresa);
      } else {
        toastShow(
          toast,
          "error",
          "Error",
          "No se encontró información de la solicitud.",
        );
      }
    } catch (error) {
      toastShow(toast, "error", "Error", "Error al cargar la solicitud.");
    }
  };

  const obtenerImagenPDF = (img) => {
    if (!img || typeof img !== "string") return null;

    const limpia = img.trim();

    if (!limpia) return null;

    if (limpia.startsWith("data:image/")) {
      return limpia;
    }

    return `data:image/png;base64,${limpia}`;
  };

  const generarPDF = async (solicitud, empresa) => {
    const logoPDF = obtenerImagenPDF(empresa.logoB64);

    const nombreProveedor =
      solicitud.NombreProveedor ||
      solicitud.CustomerName ||
      "Proveedor no disponible";

    const codigoProveedor =
      solicitud.CodigoProveedor || solicitud.CodigoCompany || "N/A";

    const fechaFormateada = solicitud.Fecha
      ? getDateStringCeros(solicitud.Fecha)
      : "N/A";

    const filasSecciones = SECCIONES.map(({ key, label }) => [
      {
        ...renderCheckboxRow(solicitud[key], label),
        colSpan: 2,
      },
      { text: "" },
    ]);

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [40, 70, 30, 70],
      defaultStyle: {
        font: "Roboto",
      },

      header: function () {
        return [
          {
            widths: [200, 350, 120],
            columns: [
              [
                logoPDF
                  ? {
                      image: logoPDF,
                      width: 190,
                      margin: [4, -10, -10, -10],
                    }
                  : {
                      text: "",
                      width: 190,
                      margin: [4, -10, -10, -10],
                    },
              ],
              [
                {
                  text: empresa.name,
                  style: "tituloEmpresa",
                  margin: [-10, 25, 0, 0],
                  width: 320,
                },
                {
                  text: empresa.direccion,
                  style: "direccionEmpresa",
                  margin: [-10, 5, 0, 0],
                  width: 320,
                },
              ],
              [
                {
                  text: `Solicitud Edición\n${solicitud?.Correlativo || ""}`,
                  style: "numeroDoc",
                  margin: [0, 35, 0, 0],
                },
              ],
            ],
          },
        ];
      },

      content: [
        {
          margin: [0, 10, 0, 0],
          table: {
            widths: [130, "*"],
            body: [
              [
                {
                  text: "Código Proveedor:",
                  style: "label",
                },
                {
                  text: `${codigoProveedor} - ${nombreProveedor}`,
                  style: "value",
                },
              ],
              [
                {
                  text: "Número Correlativo:",
                  style: "label",
                },
                {
                  text: solicitud.Correlativo || "N/A",
                  style: "value",
                },
              ],
              [
                {
                  text: "Fecha Solicitud:",
                  style: "label",
                },
                {
                  text: fechaFormateada,
                  style: "value",
                },
              ],
              [
                {
                  text: "Información a Modificar:",
                  style: "labelSection",
                  colSpan: 2,
                  margin: [0, 10, 0, 5],
                },
                { text: "" },
              ],

              ...filasSecciones,

              [
                {
                  text: "",
                  colSpan: 2,
                  border: [false, true, false, false],
                  margin: [0, 10, 0, 0],
                },
                { text: "" },
              ],
              [
                {
                  text: "Comentario:",
                  style: "label",
                },
                {
                  text:
                    solicitud.Comentario && solicitud.Comentario.trim() !== ""
                      ? solicitud.Comentario
                      : "Sin comentario",
                  style: "value",
                },
              ],
              [
                {
                  text: "",
                  colSpan: 2,
                  border: [false, true, false, false],
                  margin: [0, 10, 0, 0],
                },
                { text: "" },
              ],
              [
                {
                  colSpan: 2,
                  table: {
                    widths: ["auto", "*", "auto", "*"],
                    body: [
                      [
                        {
                          text: "Firma quien Solicita:",
                          style: "label",
                          border: [false, false, false, false],
                        },
                        {
                          text: "_____________________________",
                          style: "value",
                          border: [false, false, false, false],
                        },
                        {
                          text: "Firma quien Autoriza:",
                          style: "label",
                          border: [false, false, false, false],
                        },
                        {
                          text: "_____________________________",
                          style: "value",
                          border: [false, false, false, false],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 80, 0, 0],
                },
                { text: "" },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
            hLineWidth: function () {
              return 0;
            },
            vLineWidth: function () {
              return 0;
            },
          },
        },
      ],

      footer: function () {
        return {
          margin: [40, 0, 40, 20],
          stack: [
            {
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                        text: `${
                          empresa?.name || ""
                        }`,
                      style: "textoEmpresa",
                      alignment: "center",
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: "Km. 19.5 Carretera a occidente, La Acequia, Quimistán, Naco, Santa Bárbara, Honduras, C.A.",
                      style: "textoDireccion",
                      alignment: "center",
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              columns: [
                {
                  text: "",
                  width: "33%",
                },
                {
                  text: `Solicitado por: ${userAuth?.UserName || ""}`,
                  alignment: "center",
                  fontSize: 9,
                  width: "34%",
                },
                {
                  text: `Impreso: ${formatDate(new Date())}`,
                  alignment: "center",
                  fontSize: 9,
                  width: "33%",
                },
              ],
            },
          ],
        };
      },

      styles: {
        tituloEmpresa: {
          fontSize: 10,
          bold: true,
          alignment: "left",
        },
        direccionEmpresa: {
          fontSize: 9,
          alignment: "left",
        },
        numeroDoc: {
          fontSize: 10,
          bold: true,
          alignment: "center",
        },
        label: {
          fontSize: 11,
          alignment: "left",
          margin: [0, 5, 0, 0],
          bold: true,
        },
        labelSection: {
          fontSize: 11,
          alignment: "left",
          margin: [0, 5, 0, 0],
          bold: true,
          decoration: "underline",
        },
        checkboxLabel: {
          fontSize: 10,
          alignment: "left",
          margin: [0, 2, 0, 0],
        },
        value: {
          fontSize: 11,
          alignment: "left",
          margin: [0, 5, 0, 0],
        },
        textoEmpresa: {
          fontSize: 10,
          alignment: "center",
          bold: true,
          margin: [0, 5, 0, 0],
        },
        textoDireccion: {
          fontSize: 9,
          alignment: "center",
          lineHeight: 1.2,
        },
      },
    };

    try {
      const doc = pdfMake.createPdf(docDefinition);

      const iframe = document?.getElementById("pdfSolicitudEdicionProveedor");

      doc.getDataUrl((url) => {
        iframe?.setAttribute("src", url);
      });
    } catch (error) {
      console.log("ERROR GENERANDO PDF SOLICITUD EDICION:", error);

      toastShow(toast, "error", "Error", "Error al generar el PDF.");
    }
  };

  useEffect(() => {
    if (dialog && IdSolicitudEdicion > 0) {
      obtenerInformacion();
    }

    if (!dialog) {
      setData({});
    }
  }, [dialog, IdSolicitudEdicion]);

  return (
    <Dialog
      visible={dialog}
      onHide={hideDialog}
      style={{ width: "75vw", height: "100%" }}
      header={
        <div className="d-flex gap pt-2">
          <h3>
            {data?.NombreProveedor || "Solicitud de Edición"}
            {data?.CodigoProveedor && ` (${data.CodigoProveedor})`}
          </h3>
        </div>
      }
    >
      <Toast ref={toast} />

      <div className="d-flex justify-content-center">
        <iframe
          id="pdfSolicitudEdicionProveedor"
          src=""
          title="Reporte Solicitud Edición Proveedor"
          style={{
            width: "100%",
            height: "85vh",
            border: "1px solid #ccc",
          }}
          className="my-4"
        />
      </div>
    </Dialog>
  );
};

export default ReporteSolicitudEdicionProveedor;
